import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { CountryModal } from "../verification-steps/components/country-modal";
import CountryChevron from "../../../assets/CountryChevron.svg";
import { useNavigate } from "react-router-dom";
import { fbLogEventOnce, FB_EVENTS } from "utils/fbEvents";
import { sessionStore } from "entities/session/model/sessionModel";
import GoBack from "../../../assets/GoBackApp.svg";
import { PATH_LIST } from "shared/lib/react-router";
import { GetCountryByCode } from "static/countries";
import Button from "shared/ui/button";
import { timer } from "helpers/functions";
// import Close from "../../../assets/Close.svg";
import { sircapApi } from "shared/api/sircap";
import { toast } from "react-toastify";
import Modal from "widgets/auth/modal";
import { useStore } from "zustand";
import { accountStore } from "entities/account";
import moment from "moment";
import TermsCheckbox from "pages/onboarding/components/terms-checkbox";

type DropdownProps = {
  flag: string;
  label: string;
  selected: string;
  onClick: () => void;
};

const TaxInfoDropdown: React.FC<DropdownProps> = ({
  flag,
  label,
  selected,
  onClick,
}) => (
  <div className="tax-info-dropdown" onClick={onClick}>
    <label>{label}</label>
    <img className="tax-info-dropdown-flag" src={flag} alt="flag" />
    <div>
      <p>{selected}</p>
    </div>
    <img
      className="tax-info-dropdown-chevron"
      src={CountryChevron}
      alt="chevron"
    />
  </div>
);

type TaxInfoContainerProps = {
  item: { country: string; tin: string; reason: string; removable?: boolean };
  openModal: () => void;
  setTin: (value: string) => void;
  setReason: (value: string) => void;
  remove: () => void | undefined;
  country: string;
  showValidationErrors: boolean;
  itemIndex: number;
};

const TaxInfoContainer: React.FC<TaxInfoContainerProps> = ({
  item,
  openModal,
  setTin,
  setReason,
  remove,
  country,
  showValidationErrors,
  itemIndex,
}) => {
  const { t } = useTranslation("app");
  const [isTin, setIsTin] = useState(false);
  const [radioChecked, setRadioChecked] = useState<
    "first" | "second" | "third" | null
  >(null);

  // useEffect(() => {
  //   // If reason is not empty, it means user doesn't have TIN
  //   setIsTin(!!item.reason);
  // }, [country, item.reason]);

  // Check if this item is invalid (needs either TIN or reason)
  const isItemInvalid = showValidationErrors && !item.tin && !item.reason;

  // useEffect(() => {
  //   console.log(radioChecked);
  //   console.log(isTin);
  // }, [radioChecked, isTin]);

  return (
    <div className="tax-info-container">
      {/* {item.removable && (
        <img
          className="tax-info-close-icon"
          src={Close}
          alt="close"
          onClick={() => remove()}
        />
      )} */}

      <TaxInfoDropdown
        flag={GetCountryByCode(item.country)?.flag || ""}
        label={t("taxResidency")}
        selected={GetCountryByCode(item.country)?.name || ""}
        onClick={() => openModal()}
      />

      <div className="tax-info-tin-number">
        {!isTin && (
          <>
            <label htmlFor="tin-number">
              {t("taxpayerIdentificationNumber")}
            </label>

            <span className="tax-info-tin-number-second-label">
              {t("taxpayerIdentificationNumber2")}
            </span>

            <input
              type="text"
              value={item.tin || ""}
              onChange={(e) => setTin(e.target.value)}
              style={{
                transition: "0.3s ease",
                borderColor: isItemInvalid ? "#f84d62" : undefined,
              }}
            />
          </>
        )}

        {isTin && <p>{t("noTinOrEquivalent")}</p>}

        {isTin && <span>{t("ifTINnotAvailable")}</span>}

        {isTin && (
          <div className="tax-info-tin-number-radio-wrapper">
            {[
              {
                id: "first",
                label: t("TIN_reason1"),
              },
              {
                id: "second",
                label: t("TIN_reason2"),
                content: true,
              },
              {
                id: "third",
                label: t("TIN_reason3"),
              },
            ].map((i, index) => (
              <React.Fragment key={index}>
                <div key={index} className="tax-info-tin-number-radio">
                  <input
                    type="radio"
                    id={itemIndex + i.id}
                    checked={radioChecked === itemIndex + i.id}
                    onChange={() => {
                      setRadioChecked(
                        (itemIndex + i.id) as typeof radioChecked
                      );
                      !i.content ? setReason(i.label) : setReason("");
                    }}
                  />
                  <label htmlFor={itemIndex + i.id}>{i.label}</label>
                </div>

                {i.content && radioChecked === itemIndex + i.id && (
                  <div className="tax-info-tin-number-radio-content">
                    <label>{t("explainTinIssue")}</label>
                    <input
                      type="text"
                      value={item.reason || ""}
                      onChange={(e) => {
                        // setReason(e.target.value);
                        setReason(e.target.value);
                      }}
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        )}

        <button
          onClick={() => {
            setIsTin(!isTin);
            // setReason(isTin ? "" : t("noTinOrEquivalent"));
            setReason("");
            setTin("");
            setRadioChecked(null);
          }}
        >
          {isTin ? t("haveTIN") : t("dontHaveTIN")}
        </button>
      </div>
    </div>
  );
};

type TaxInfo = {
  country: string;
  tin: string;
  reason: string;
  removable?: boolean;
};

export const TaxInformationPage = () => {
  const { t: o } = useTranslation("onboarding");
  const { t } = useTranslation("app");
  const navigate = useNavigate();
  // const { crsData } = useStore(sessionStore);
  const [modalOpened, setModalOpened] = useState<number | null>(null);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [pinModal, setPinModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dealError, setDealError] = useState(false);
  const { kyc } = useStore(accountStore);
  const [isChecked, setIsChecked] = useState(false);

  const [haveAnotherResidency, setHaveAnotherResidency] = useState(false);
  const scrollableContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (
      kyc?.status === 3 &&
      (!kyc?.end_datetime ||
        moment(kyc?.end_datetime).isBefore(moment("2025-10-04", "YYYY-MM-DD")))
    ) {
      setHaveAnotherResidency(true);
    } else {
      setHaveAnotherResidency(false);
    }
  }, [kyc]);

  // const [localTin, setLocalTin] = useState(item.tin);
  // const [localReason, setLocalReason] = useState(item.reason);

  const handleNavigate = () => {
    navigate(PATH_LIST.account);
  };

  const closeModal = () => setModalOpened(null);

  const [taxInfoArray, setTaxInfoArray] = useState<TaxInfo[]>([
    {
      country: "ARM",
      tin: "",
      reason: "",
    },
  ]);

  const modalProps = {
    onClose: closeModal,
    onSelect: (country: string) => {
      if (modalOpened === taxInfoArray.length) {
        // Adding a new item
        const newItem = {
          country: country,
          tin: "",
          reason: "",
          removable: true,
        };
        setTaxInfoArray((prev) => [...prev, newItem]);

        // Scroll to bottom after adding new item
        timer(0.2).then(() => {
          if (scrollableContainerRef.current) {
            scrollableContainerRef.current.scrollTo({
              top: scrollableContainerRef.current.scrollHeight,
              behavior: "smooth",
            });
          }
        });
      } else {
        // Updating existing item
        setTaxInfoArray((prev) => {
          const newArray = [...prev];
          newArray[modalOpened!].country = country;
          return newArray;
        });
      }
      closeModal();
    },
    label: o("residency"),
    selectedName:
      modalOpened === taxInfoArray.length
        ? undefined
        : GetCountryByCode(taxInfoArray[modalOpened!]?.country || "ARM")?.name,
    diffGoBackIcon: true,
    usedCountries: taxInfoArray.map((item) => item.country),
  };

  const handleAdd = () => {
    // Open country modal for new item selection
    setModalOpened(taxInfoArray.length); // Use next index for new item
  };

  const handleRemove = (index: number) => {
    setTaxInfoArray((prev) => {
      const newArray = [...prev];
      newArray.splice(index, 1);
      return newArray;
    });
  };

  const handleSetTin = (index: number, value: string) => {
    setTaxInfoArray((prev) => {
      const newArray = [...prev];
      newArray[index].tin = value;
      return newArray;
    });
    // Clear validation errors when user starts typing
    if (showValidationErrors) {
      setShowValidationErrors(false);
    }
  };

  const handleSetReason = (index: number, value: string) => {
    setTaxInfoArray((prev) => {
      const newArray = [...prev];
      newArray[index].reason = value;
      return newArray;
    });
    // Clear validation errors when user starts typing
    if (showValidationErrors) {
      setShowValidationErrors(false);
    }
  };

  const isValid = taxInfoArray.every((item) => {
    if (item.tin) {
      return true;
    } else if (item.reason) {
      return true;
    }
    return false;
  });

  const handleSubmitWithPin = async (pinCode: string) => {
    setDealError(false);
    setIsLoading(true);

    try {
      // Prepare the data for submission
      const currentYear = new Date().getFullYear();
      const crsData = {
        year: currentYear,
        data: taxInfoArray.map((item) => ({
          country: item.country,
          tin: item.tin || "",
          reason: item.reason || "",
        })),
        pinCode,
      };

      const response = await sircapApi.auth.crsData(crsData);

      if (response.error) {
        console.error("Failed to submit CRS data:", response.error);
        setDealError(true);
        toast.error("Failed to submit CRS data");
        return;
      }

      // Update session store with CRS data
      sessionStore.getState().updateCrsData([crsData]);
      void fbLogEventOnce(
        `tax_info_${sessionStore.getState().user?.id}`,
        FB_EVENTS.taxInfoSigned,
      );
      toast.success(t("CRSSubmitted"));
      setPinModal(false);
      navigate(PATH_LIST.account);
    } catch (error) {
      console.error("Error submitting CRS data:", error);
      setDealError(true);
      toast.error("Server Error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async ({
    forOnlyArmenia,
  }: {
    forOnlyArmenia?: boolean;
  }) => {
    console.log(forOnlyArmenia, isValid);

    if (!forOnlyArmenia && !isValid) {
      setShowValidationErrors(true);
      return;
    }

    setPinModal(true);
  };

  // useEffect(() => {
  //   console.log(taxInfoArray);
  // }, [taxInfoArray]);

  return (
    <div className="tax-info">
      <div className="tax-info-header">
        <img
          className="go-back-portfolio"
          onClick={handleNavigate}
          src={GoBack}
          alt="Go Back"
        />
        <p>{t("taxInformation")}</p>
      </div>

      <div className="tax-info-main" ref={scrollableContainerRef}>
        {taxInfoArray.map((item, index) => (
          <TaxInfoContainer
            item={item}
            itemIndex={index}
            key={index}
            openModal={() => {
              setModalOpened(index);
            }}
            remove={() => handleRemove(index)}
            setTin={(value) => handleSetTin(index, value)}
            setReason={(value) => {
              handleSetReason(index, value);
            }}
            country={item.country}
            showValidationErrors={showValidationErrors}
          />
        ))}

        <button className="tax-info-new-tin-button" onClick={handleAdd}>
          <p>+</p>
          <p>{t("addCountryOfTaxResidency")}</p>
        </button>
      </div>

      <div className="tax-info-bottom-wrapper">
        <TermsCheckbox
          term={t("confirmNoOtherTaxResidency")}
          htmlForId="1"
          isChecked={isChecked}
          onChange={() => {
            setIsChecked(!isChecked);

            if (showValidationErrors) {
              setShowValidationErrors(false);
            }
          }}
        />
        <div className="tax-info-buttons">
          <Button
            type="submit"
            className="contract-sign-btn"
            variant="dark"
            onClick={handleSubmit}
            disabled={!isValid || isLoading || !isChecked}
          >
            {t("confirmAndSign")}
          </Button>
        </div>
      </div>

      {modalOpened !== null && <CountryModal {...modalProps} />}

      {pinModal && (
        <Modal
          customModal="modalLogOut"
          onClick={handleSubmitWithPin}
          onHide={() => {
            setPinModal(false);
            setDealError(false);
          }}
          title={t("confirmAndSign")}
          text={t("enterPin")}
          btnText={t("confirmAndSign")}
          showSecondBtn={false}
          customOutlet="customOutlet"
          confirmDeal={true}
          isLoading={isLoading}
          dealError={dealError}
        />
      )}

      {haveAnotherResidency && (
        <Modal
          customModal="have-another-residency-modal"
          onClick={() => {
            setHaveAnotherResidency(false);
          }}
          onClickSecondBtn={() => {
            handleSubmit({ forOnlyArmenia: true });
            setHaveAnotherResidency(false);
          }}
          onHide={() => {
            setPinModal(false);
            setDealError(false);
          }}
          title={t("haveAnotherResidency")}
          text=""
          btnText={t("yes")}
          btnText2={t("no")}
          showSecondBtn={true}
          customOutlet="customOutlet"
        />
      )}
    </div>
  );
};
